export default "__VITE_ASSET__BPioU96T__"